const retirement401KInfo = [
    {shortName: "Conservative", longName: "Conservative Income Fund",
        shortDesc: "Bonds / Cash heavy",
        Objective:  "Preserve capital and provide modest, steady growth.",
        GeneralDesc: "This portfolio primarily invests in bonds and fixed-income assets, " +
            "which are generally less volatile than stocks. It is designed to reduce the " +
            "risk of significant short-term losses, though it may offer lower long-term " +
            "returns compared to more aggressive options.",
        BestSuitedFor: "Best suited for:",  
        BestSuitedUlArr: ["Investors nearing retirement", 
            "Those with a low tolerance for risk", 
            "Individuals who prefer stability over growth"],
        KeyCharacteristics: "Key Characteristics: ",
        KeyCharULArr: ["Lower potential returns",
            "Lower risk and volatility",
            "Focus on capital preservation"]
    },
    {shortName: "Balanced", longName: "Moderate Allocation Fund",
        shortDesc: "60/40 stock/bond mix",
        Objective:  "Provide a moderate level of growth with controlled risk.",
        GeneralDesc: "This option offers a diversified mix of stocks and bonds, aiming " +
            "to balance the potential for growth with a level of stability. It is appropriate " +
            "for investors seeking long-term growth but who also want to manage risk." ,
        BestSuitedFor: "Best suited for:",  
        BestSuitedUlArr: ["Mid-career employees", 
        	"Investors with a moderate risk tolerance",
            "Those looking for a balance between growth and protection"],
        KeyCharacteristics: "Key Characteristics: ",
        KeyCharULArr: ["Moderate potential returns",
            "Moderate risk and volatility",
            "Diversified across multiple asset classes"],
    },
     {shortName: "Aggressive", longName: "Aggressive Growth Fund",
        shortDesc: "Mostly equities (stocks)",
        Objective:  "Provide a moderate level of growth with controlled risk.",
        GeneralDesc: "This portfolio is heavily weighted toward equities (stocks) and is " +
            "intended for investors with a longer time horizon and higher risk tolerance. " +
            "While this strategy may experience more short-term fluctuations, it has the " +
            "greatest potential for long-term growth." ,
        BestSuitedFor: "Best suited for:",  
        BestSuitedUlArr: ["Younger employees with many years until retirement",
        	"Investors comfortable with market ups and downs",
            "Those focused on maximizing long-term gains"],
        KeyCharacteristics: "Key Characteristics: ",
        KeyCharULArr: ["Higher potential returns",
            "Higher risk and short-term volatility",
            "Emphasis on long-term capital growth"],
    },
]   

export default retirement401KInfo;